// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';

export const HelpContent = styled.div`
    padding-top: 12px;
`;
